var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshDialog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731409725644,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 37638,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.888708 337.305392c84.795117-84.795117 214.383723-96.878942 312.512716-36.876501-33.33469 32.918006-71.461241 71.252899-71.461241 71.252899-26.876094 32.084639 3.125127 50.835402 18.542421 50.210377h248.343439c9.375381 0 17.084028-7.708647 17.084028-17.29237V158.339776c1.250051-22.500916-23.542625-44.376806-49.168667-19.167446 0 0-42.293388 41.251679-71.252899 70.002848-149.172737-108.962767-359.597965-96.6706-494.395117 38.126551-78.753204 78.753204-115.421363 183.132452-111.046186 286.053307h127.296847c-4.375178-70.21119 19.792472-142.089115 73.544659-196.049644z",
    fill: "currentColor",
    "p-id": 37639,
    "data-spm-anchor-id": "a313x.search_index.0.i50.43e13a81MrmXsx",
    className: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760.655951 490.644964c4.58352 70.419532-19.792472 142.297457-73.544659 196.049644-84.795117 84.795117-214.383723 96.878942-312.512716 36.876501 33.33469-32.918006 71.461241-71.252899 71.461241-71.252899 26.667752-32.292981-3.333469-50.835402-18.542421-50.210377H179.173957c-9.583723 0-17.29237 7.708647-17.29237 17.084029v246.26002c-1.041709 22.500916 23.750966 44.376806 49.168667 19.167447 0 0 42.293388-41.043337 71.461241-70.002849 149.172737 109.171109 359.597965 96.6706 494.186776-38.126551 78.753204-78.544863 115.421363-182.92411 111.046185-286.053306l-127.088505 0.208341z",
    fill: "#2e8f79",
    "p-id": 37640,
    "data-spm-anchor-id": "a313x.search_index.0.i51.43e13a81MrmXsx",
    className: "selected"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshDialog);
export default __webpack_public_path__ + "static/media/refresh-dialog.b39133c8936fd8e257ac0ff251b9a85d.svg";
export { ForwardRef as ReactComponent };